import _mergeJSXProps from './node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.mjs';

var BagListenBgIcon = {
  name: 'BagListenBgIcon',
  props: {},
  functional: true,
  render(h, ctx) {
    const attrs = ctx.data.attrs || {};
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      "attrs": {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 148 148"
      },
      "class": "c-ficon c-ficon--bag-listen-bg"
    }, ctx.data]), [h("path", {
      "attrs": {
        "d": "m10.6 33.6 12.5 58.5h115.2L10.6 33.7Z",
        "fill": "#DEE8A3"
      }
    }), h("path", {
      "attrs": {
        "d": "m64 94.7.4-27.4 6.5-24 21.6-.8 16.4-.3 7 .6s-1.6 6.7-1.4 9.8l5.2.3-2.7 10.8-.8 2.6-1.7 28.1-16.9-1.2c-6.1.7-33.5 1.5-33.5 1.5Z",
        "fill": "#fff"
      }
    }), h("path", {
      "attrs": {
        "d": "m109 42.1 12.2 1.5-4.7 23.5-2 27.3-11.8.2s1.7-22.8 3-29c1.2-6.4 3.2-23.4 3.2-23.4Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m126.9 52.4-12.3.2s-.2-5.8.6-8c.7-2.1 2.5-6.2 2.5-6.2l9.9 2.7c.7.3 2.7 2.3 2.6 3.8a26.3 26.3 0 0 1-.9 5.6c-.4 1.1-2.4 1.9-2.4 1.9ZM36.5 103s-6.4-1.5-7.7-2.4c-1.4-1-1.7-3.6-1.4-5.6.3-2 .8-3.7 2.6-4.7 1.7-1 9.5-2 9.5-2s2.8-1.1 4-.6c1.1.6 2 1.3 2 2.8 0 1.5.7 4.2 0 6l-2 4.4-2.8 2s-2.4 1.8-4.2 0Z",
        "fill": "#82C9E3"
      }
    }), h("path", {
      "attrs": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M95.2 73.2 92.3 69v-3.7c0-.2-.1-.4-.3-.5l-.8-.4a.6.6 0 0 0-.8.3l-.2 1.3-.4-.5c-.5-.8-1-1.5-1.7-2.2-.8-.7-1.6-.8-2.6-.3-4.3 2-8 5.2-11 8.9a.6.6 0 0 0 .1.8c.8.6 1.7 1 2.7 1-.4 2-.8 4-.8 6 0 1.1 1 1.2 1.9 1.3h.2l1.4.1c.1-1.6.4-3.2.8-4.7l-.3-.2c-.5-.3-.8-.9-.8-1.5L80 73v-.2l.6-2.2c0-.5.8-.3.7.2l-.4 1.6v.3l-.1.4-.1.5a.4.4 0 0 1 0 .2l.3.3a2.7 2.7 0 0 0 .5.1l.8-3.5c.1-.5.9-.3.7.2l-.6 2.5-.1.8.9-.1.6-2.2c0-.4.2-.7.3-1.1.1-.5.9-.3.8.2l-.3 1-.8 2.5a5.1 5.1 0 0 1-.6 1.6 1 1 0 0 1-.9.4 5.5 5.5 0 0 1-.4 0l-.6 4.8 1.4.1 3.4.2.6-2.5h-.3c-.3 0-.6 0-.9-.2a.6.6 0 0 1-.3-.3.4.4 0 0 1-.1-.4 14.2 14.2 0 0 1 3.5-7.4c.1-.4.8-.4.8.1v.2A86.5 86.5 0 0 1 88 81.5a5.1 5.1 0 0 0 2.2-.5c.9-.5 1-1.5 1.2-2.4v-.4l.8-3.8c.9 0 1.7-.1 2.5-.4a.6.6 0 0 0 .4-.8Zm-19.5-1V72a1 1 0 0 0 .1.2h-.1Zm6.4-3.7v.1-.1Zm7.1-2 .9 1.2v.2l.2.1-1.1-1.5Zm2 .9v-.1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m33 74.3-2.4-6.9s-5.3-1.7-7.1-5.5c-1.8-3.7-2-8 0-11.8 2.1-3.7 4.8-5.3 8.8-6.2 4-1 7.4.3 9.3 1.2 1.9.8 6.4 4.5 7 8.8.6 4.2 0 7.2-3 10.2-2.9 3-10.3 3.3-10.3 3.3l-2.2 7Z",
        "fill": "#fff"
      }
    }), h("path", {
      "attrs": {
        "d": "M32.4 64a10.8 10.8 0 0 1-7.3-9.5A11.9 11.9 0 0 1 31 43.9c4-2.4 9.4-2 13.4.4 3.8 2.4 6.4 7 5.6 11.5a9.5 9.5 0 0 1-4 6.3 13 13 0 0 1-8.2 2.4c-1.3-.2-1.2 1.8 0 2 2.8.3 6-.8 8.5-2.2 2.3-1.3 4.2-3.5 5-6 2-5.2 0-10.9-4.1-14.4a15.3 15.3 0 0 0-15.5-2.6A14 14 0 0 0 23.1 53 12.9 12.9 0 0 0 32 66c1.2.4 1.7-1.6.5-2Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m36.6 65-2 7.6c-.4 1.3 1.5 1.8 1.9.5l2-7.6c.3-1.2-1.6-1.8-2-.5Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M31.4 65.4a43 43 0 0 1 3 7.6c.3 1.2 2.2.7 1.9-.5a44.4 44.4 0 0 0-3.2-8.2c-.6-1.1-2.3 0-1.7 1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M118.6 52.6c-.9 4.3-2 8.7-3.4 13-.4 1.3 1.8 2 2.3.5 1.3-4.2 2.5-8.5 3.3-12.9.3-1.5-2-2.1-2.2-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M115 66.3c0 9.5-.6 19-1.8 28.3-.1 1.5 2.2 1.5 2.4 0 1.1-9.4 1.7-18.9 1.8-28.3 0-1.5-2.4-1.5-2.4 0Zm.3-24.7-6.4-.6c-1.5-.2-1.5 2.2 0 2.3 2.1.3 4.3.5 6.4.6 1.5.1 1.5-2.2 0-2.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M108.8 41.1c-12.6 0-25.3.1-38 1-1.4.1-1.4 2.5 0 2.4 12.7-1 25.4-1 38-1 1.5 0 1.5-2.4 0-2.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M69.5 43c-2.3 8.2-4.3 16.5-6 24.9-.2 1.4 2 2 2.3.6a313.8 313.8 0 0 1 6-24.9c.4-1.5-1.9-2-2.3-.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m63.5 68.1-.6 26.5c0 1.5 2.3 1.5 2.4 0l.5-26.5c0-1.5-2.3-1.5-2.3 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M64 95.8a211 211 0 0 0 33.6-1.5c1.5-.2 1.5-2.5 0-2.3a210 210 0 0 1-33.5 1.5c-1.5 0-1.5 2.3 0 2.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M97.2 94.3a60.5 60.5 0 0 0 17.3 1.3c1.5-.1 1.5-2.5 0-2.4-5.6.5-11.2 0-16.7-1.1-1.5-.3-2.1 2-.6 2.2ZM85.4 42.6c.2-1.6.6-3.3 1-4.9.5-1.5-1.8-2-2.2-.6a35.5 35.5 0 0 0-1.2 5.5c0 .7.6 1.2 1.2 1.2.7 0 1.1-.5 1.2-1.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M85.3 38.3a77.6 77.6 0 0 1 9.3-.4c.7 0 2-.1 2.6.3 1.3.8 2.5-1.3 1.2-2-.8-.6-1.7-.6-2.7-.6a70.3 70.3 0 0 0-10.4.3c-1.5.1-1.6 2.6 0 2.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M96.4 37.2a29 29 0 0 1-.6 4.6c-.4 1.5 2 2.1 2.3.6.4-1.7.6-3.5.7-5.2.1-1.6-2.3-1.6-2.4 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M94 42.3a10.3 10.3 0 0 1 3.3-3.3c1.3-.8 0-2.9-1.2-2a13 13 0 0 0-4.2 4c-.8 1.4 1.3 2.6 2 1.3Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M96.7 39.2c3-.4 6 0 9 .3 1.5.2 1.5-2.2 0-2.4-3-.4-6-.7-9-.3-1.5.2-1.5 2.6 0 2.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M104.7 37.7a44.5 44.5 0 0 1-2.8 3.6c-1 1.1.7 2.8 1.7 1.7a50 50 0 0 0 3.2-4c.9-1.3-1.2-2.5-2-1.3Zm-27 57.4c-.5 2.8-1.4 5.5-1.6 8.4-.2 1.5 2.2 1.5 2.4 0 .2-2.6 1-5.2 1.6-7.8.3-1.5-2-2.1-2.3-.6Zm18.9-1c-.2 3-1 5.9-1.2 8.9 0 1.5 2.3 1.5 2.4 0 .2-3 1-6 1.2-9 0-1.5-2.3-1.5-2.4 0ZM118 39.3a61.4 61.4 0 0 1 10.7 3.3c1.3.6 1.9-1.5.6-2a61.2 61.2 0 0 0-10.7-3.4c-1.4-.3-2 1.8-.6 2.1Zm-2.8 14.4c4 0 8.2.3 12.2-.4 1.4-.2.8-2.3-.5-2-3.9.6-7.8.3-11.7.2-1.4 0-1.4 2.1 0 2.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M117.6 36.4a29 29 0 0 0-4 18.1c.1 1.4 2.3 1.4 2.2 0-.6-5.9.5-12 3.7-17 .7-1.2-1.2-2.3-2-1.1Zm10.6 6c1.1 1.2 1 3 .8 4.6-.3 1.3-.8 3.7-2 4.4-1.2.7 0 2.6 1.1 1.9 2-1.1 2.7-4 3-6 .4-2.3.3-4.7-1.4-6.4-1-1.1-2.5.5-1.5 1.5Zm-19.9.4c-.6 2.8-1 5.6-1.3 8.4-.2 1.5 2.2 1.5 2.3 0a93 93 0 0 1 1.3-7.8c.2-1.5-2-2.1-2.3-.6Zm-5.2 42.4c-.5 2.7-.6 5.4-1 8-.3 1.6 2 2.2 2.2.7.4-2.7.5-5.4 1-8 .4-1.6-1.9-2.2-2.2-.7Zm1.9-21.8c-.7 2.9-1 5.8-1.2 8.7 0 1.5 2.3 1.5 2.3 0 .2-2.7.6-5.4 1.1-8 .3-1.6-2-2.2-2.2-.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M112 60c3.9 0 7.7-.6 11.2-2.1 1.6-.7 3.3-1.4 4.3-3 1-1.4 1-3 .7-4.7-.3-1.4-2.5-.8-2.2.6.3 1.4.2 2.8-1 3.7a25 25 0 0 1-13 3.3c-1.3 0-1.3 2.1 0 2.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M128 49.7a7.6 7.6 0 0 0-2-2.3c-.4-.4-1-.5-1.5 0-.4.4-.4 1.2 0 1.6a5.9 5.9 0 0 1 1.5 1.8 1.1 1.1 0 1 0 2-1.1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M126.9 49.4a14.7 14.7 0 0 0-3.1-.3c-1.4 0-1.4 2.2 0 2.2.8 0 1.7 0 2.5.2 1.4.3 2-1.8.6-2.1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M125.9 50.6c-.9.6-1.8 1-2.8 1.2-1.4.4-.8 2.5.6 2.1 1.2-.3 2.3-.8 3.3-1.4 1.2-.8.1-2.7-1-1.9Zm-7.4 1.9a14 14 0 0 1 0-4.2c0-1-1.5-1-1.6 0-.2 1.5-.2 3 0 4.6.2 1 1.7.6 1.6-.4Zm.4-7a5 5 0 0 1 .3-1 .8.8 0 0 0-.3-1.2c-.3-.2-.9 0-1 .3l-.6 1.4c0 .4.2.9.6 1 .4.1 1-.1 1-.6Zm1.5-4.2 1-1.7a.8.8 0 0 0-.3-1 .8.8 0 0 0-1 .2l-1 1.7a.8.8 0 1 0 1.3.8Zm8.3-.3c-1 .1-2 .8-2.5 1.8-.5.9 1 1.7 1.4.8.3-.7.9-1 1.6-1.1.4 0 .6-.6.5-1-.1-.5-.5-.6-1-.6ZM67.8 51.2a7.7 7.7 0 0 0-4.7 6.2c-.4 3 1.1 5.6 3.6 7.2 2.6 1.7 6 1.9 9 1 1.6-.6 3.1-1.3 4.6-2.3 1.3-1 2.8-2 3.4-3.4.6-1.3-1.3-2.4-1.9-1.1-.5 1.1-1.6 1.9-2.6 2.6a16.2 16.2 0 0 1-3.7 1.9c-2.3.8-4.8 1-7-.2-1.9-1-3.3-2.7-3.3-5a5.5 5.5 0 0 1 3.2-4.8c1.3-.5.7-2.6-.6-2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M83.6 58.7a1.1 1.1 0 0 1 .3-1.2c1-1-.6-2.6-1.6-1.6a3.4 3.4 0 0 0-.8 3.4c.2.6.8.9 1.3.8.6-.2 1-.8.8-1.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M82.1 58.2H82s-.2-.1 0 0h-.1a1 1 0 0 1 0-.1c-.2-.2 0 0 0 0-.2-.2-.1 0 0 0a.8.8 0 0 1-.1-.2v.1a.7.7 0 0 1 0-.2c0-.6-.6-1.1-1.1-1.1-.6 0-1.1.5-1.1 1-.1 1.5 1.1 2.7 2.5 2.7.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M84 60s0 .1 0 0c0 0 0 .2 0 0 .2 0 0 0 0 0h.1c-.1 0 0 0 0 0 .2 0-.1 0 0 0 0 0 .2 0 0 0s.3.2 0 0c.5.2 1.2.2 1.5-.4.2-.5.1-1.3-.4-1.5a2.3 2.3 0 0 0-3.2 1.3c-.2.5.2 1.2.7 1.4.6.1 1.2-.2 1.4-.8ZM43 86.6c-3.6 0-5.7 3.3-6.6 6.4a32.4 32.4 0 0 0-1.2 5.3c-.3 1.7-.3 3.4.6 5 1.8 3.3 5.8.9 7.6-1.2 2.3-2.8 3.2-6.5 3.3-10 .1-1.7 0-3.8-1.5-4.9-1.4-1-3.4-.5-4.9.1-1.3.6-.1 2.5 1.1 2 .6-.3 1.4-.6 2-.5.7.2 1 .8 1 1.4.4 1.5 0 3.2-.2 4.7-.5 2.9-1.8 6-4.5 7.4-.6.3-1.3.7-1.8.2-.5-.5-.6-1.5-.7-2.2 0-1.6.4-3.2.7-4.8.6-2.5 1.8-6.7 5-6.6 1.5 0 1.5-2.2 0-2.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m40.9 87.3-5 .5c-1.6.2-3.3.3-4.8.7-1.4.3-.8 2.4.6 2 1.5-.3 3-.3 4.6-.5l4.6-.5c1.4-.2 1.4-2.4 0-2.2Zm-4.6 14A83.6 83.6 0 0 0 30 100c-1.4-.3-2 1.8-.6 2l6.3 1.5c1.4.3 2-1.8.6-2.1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M31.4 88.3c-2.8.5-4.5 4.2-5 6.7-.4 2.6 0 6.9 3.5 7 1.4 0 1.4-2.1 0-2.2-2 0-1.4-4-1.1-5.1.4-1.6 1.4-4 3.2-4.3 1.4-.2.8-2.3-.6-2.1Zm3 13.3a4.7 4.7 0 0 1-.4-2.3c0-.4-.4-.8-.8-.8s-.7.4-.8.8c0 1 0 1.9.4 2.7.1.4.5.7 1 .6.4-.1.7-.6.5-1Zm-.4-5.4.5-1.8c.3-1-1.3-1.4-1.5-.4l-.5 1.8c-.3 1 1.3 1.4 1.6.4Zm1.4-4.5 1.7-2c.7-.7-.5-1.8-1.2-1l-1.7 1.8c-.7.8.5 2 1.2 1.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M27.4 94.5c-1.9 0-3.7.4-5.4 1a11.4 11.4 0 0 0-4.3 2.5c-1 1-1.5 2.4-1.1 3.7a4.3 4.3 0 0 0 2.3 2.5 8.3 8.3 0 0 0 3.9.8c1.6 0 3.3-.3 5-.1 1 .1 4 1.1 2.6 2.6-1 1-2.5 1-3.7 1.3-1.1.2-2.4.7-2.9 1.9-.5 1.3.5 2.7 1.8 3.2 1.6.6 3.6 0 5.3-.3l6.1-.7c8-.5 16 .2 24.1.5 4 .1 8 .2 12.1 0l12.2-.9c4-.3 8-.4 12.1 0 4 .3 8.2.9 12.3 1 6.2.2 12.9-1 17.7-5.3 2.3-2 3.9-4.8 4.5-7.8.7-3.6.3-7.3.4-11 .2-3.9 1.2-7.7 2.2-11.5 1-3.6 1.8-7.2 2.1-10.9.4-3.6.2-7.2-.7-10.7-.7-3-2-6.5-4.5-8.6a6.2 6.2 0 0 0-3.7-1.5c-.7 0-.7 1 0 1 3 .2 5 3.1 6.1 5.7a27.8 27.8 0 0 1 2 10.3c0 3.5-.4 7-1.2 10.4-.8 3.7-2 7.2-2.7 11-.7 3.5-.5 7-.6 10.6 0 3.4-.4 6.8-2.3 9.7-3.1 4.8-9.2 7-14.7 7.5-3.9.3-7.7 0-11.6-.4-3.8-.4-7.6-.8-11.5-.7-7.8 0-15.5 1.2-23.3 1.2-7.7 0-15.4-.7-23.1-.8-3.9 0-7.7.1-11.5.5-1.9.3-3.7.7-5.6.9-.8 0-1.8 0-2.5-.5-.5-.4-.8-1.2-.4-1.8.6-1 2.2-1.1 3.2-1.2 1.2-.2 2.5-.7 3.2-1.7.9-1.1.2-2.4-.9-3.1-1.2-.8-2.8-1-4.3-1-2.6.1-5.7.8-7.8-1.2-1-1-1-2.4-.2-3.5 1-1.3 2.7-2 4.1-2.6 1.7-.6 3.4-1 5.2-1 .6 0 .6-1 0-1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M85.5 49.8a2.9 2.9 0 0 0 3 2c1.4-.1 2.4-1.4 2.5-2.7 0-.8-1.2-.8-1.2 0-.2 1.8-2.6 2-3.1.3-.3-.7-1.4-.4-1.2.4Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m82.7 47-.2.4v.5a.6.6 0 0 0 1 .1l.2-.3a.6.6 0 0 0-1-.6Zm12.6.5v.2c0 .2 0 .3.2.4l.2.2h.2a.6.6 0 0 0 .6-.6v-.2a.6.6 0 0 0-.2-.4.4.4 0 0 0-.2-.2.4.4 0 0 0-.2 0 .6.6 0 0 0-.6.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m109.3 36.5 1.9 1.4c.5.4 1.4.1 1.7-.4.4-.7.2-1.4-.4-1.8l-2-1.4c-.5-.4-1.4-.1-1.7.4-.4.7-.1 1.4.5 1.8ZM106 47.2l3 .3c.7.1 1.3-.6 1.3-1.2 0-.8-.6-1.3-1.3-1.3l-3-.4c-.7-.1-1.3.6-1.3 1.3 0 .7.6 1.2 1.3 1.3Zm0 10 1.8-.3c.7-.2 1-1 .9-1.6a1.3 1.3 0 0 0-1.6-1l-1.9.5c-.7.2-1 .9-.9 1.6.2.6 1 1 1.6.9Z",
        "fill": "#FF8000"
      }
    })]);
  }
};

export { BagListenBgIcon as default };
